import { Endpoint } from '@/types';
import { ApiDocsPanel } from './ApiDocsPanel';

interface EndpointApiDocsTabProps {
  endpoint: Endpoint;
}

/**
 * The endpoint hub's API Docs tab. Projects the endpoint into an OpenAPI 3.1
 * document (client-side, no network call) and presents it two ways: the Swagger
 * UI interactive renderer, and the raw JSON spec with copy/download.
 *
 * When the Account has deployment environments (task 799), the document carries
 * one `servers` entry per environment — so Swagger's server picker offers every
 * stage — and the same `EnvironmentUrlList` the Releases surface uses sits above
 * it, for a reader who wants the URL without reading the spec. With no
 * environments, or the lever off, the tab is exactly what it was.
 *
 * The surface itself moved to `ApiDocsPanel` in task 821, when the Developer
 * Info tab needed the same document. This tab is now the panel plus the one
 * thing that is specific to it: the environment URL list, which belongs here
 * because this is the only place the Advanced page shows those URLs. What the
 * tab renders is unchanged.
 */
export function EndpointApiDocsTab({ endpoint }: EndpointApiDocsTabProps) {
  return <ApiDocsPanel endpoint={endpoint} showEnvironmentUrls />;
}
